import { useState } from "react";
import { InlineWidget } from "react-calendly";

import {
  Box,
  Grid,
  Typography,
  Tab,
  Tabs,
  Avatar,
  useTheme
} from "@mui/material";
import MessageIcon from "@mui/icons-material/Message";

import SlideLayout from "../layouts/SlideLayout";
import SupportSlider from "./SupportSlider";

import { useSubscriptionType } from "../../helpers/hooks/companyData";

import { useAuth, useAccountData } from "../../helpers/firebase";

const CommunicationCenter = ({ initialTab = "help", ...props }) => {
  const { palette } = useTheme();

  const [user] = useAuth();
  const { displayName, email } = user || {};
  const [{ name }] = useAccountData();
  const [{ type }] = useSubscriptionType("saas");
  const [selectedTab, setSelectedTab] = useState(initialTab);

  const conciergeTab =
    type === "concierge" ? [{ label: "Turnkey", value: "turnkey" }] : [];

  const tabs = [
    { label: "Help", value: "help" },
    { label: "Talk to Sales", value: "sales" },
    ...conciergeTab
  ];

  const tabsContent = {
    help: (
      <SupportSlider email={email} userName={displayName} companyName={name} />
    ),
    sales: (
      <InlineWidget url="https://calendly.com/tyler-aclymate/intro-meeting" />
    ),
    turnkey: (
      <InlineWidget url="https://calendly.com/travis-kruse/meet-with-aclymate" />
    )
  };

  return (
    <SlideLayout
      {...props}
      header={
        <Grid container spacing={2}>
          <Grid item>
            <Avatar
              style={{ backgroundColor: palette.primary.main, color: "white" }}
            >
              <MessageIcon />
            </Avatar>
          </Grid>
          <Grid item>
            <Typography variant="h4">Communication Center</Typography>
          </Grid>
        </Grid>
      }
      selectedTab={selectedTab}
      setSelectedTab={setSelectedTab}
      content={
        <Box display="flex" flexDirection="column" style={{ height: "100%" }}>
          {tabs.length > 1 && (
            <Tabs
              value={selectedTab}
              onChange={(e, val) => setSelectedTab(val)}
            >
              {tabs.map(({ value, label }, idx) => (
                <Tab key={`tab-${idx}`} label={label} value={value} />
              ))}
            </Tabs>
          )}
          <Box flexGrow={1} py={2}>
            {tabsContent[selectedTab]}
          </Box>
        </Box>
      }
    />
  );
};
export default CommunicationCenter;
